import { IconLibrary } from '@product-framework/index';
import LiveCalendar from './pages/LiveCalendar';
import DefaultSchedules from './pages/DefaultSchedules';
import SpecialSchedules from './pages/SpecialSchedules';

const AvailabilityStepperConfig = () => [
  {
    id: 'LIVE_CALENDAR',
    label: 'Live Calendar',
    Component: LiveCalendar,
    Icon: IconLibrary.LiveCalendar,
  },
  {
    id: 'DEFAULT_SCHEDULES',
    label: 'Default Schedules',
    Component: DefaultSchedules,
    Icon: IconLibrary.DefaultSchedule,
  },
  {
    id: 'SPECIAL_SCHEDULES',
    label: 'Special Schedules',
    Component: SpecialSchedules,
    Icon: IconLibrary.SpecialSchedules,
  },
];

export default AvailabilityStepperConfig;
